 $(document).ready(function(){
$('.best-seller-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
    accessibility:true,
  slidesToShow: 4.1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  // Show the first tab by default
  $('.tabs-stage > div').hide(); // Hide all tab content
  $('.tabs-stage > div:first').show(); // Show the first tab content
  $('.tabs-nav li:first').addClass('tab-active'); // Highlight the first tab

  // Show the first tab image by default
  $('.tabs-stage-images-item:first').addClass('tab-active'); // Highlight the first tab image

  // Change tab class and display content
  $('.tabs-nav a').on('click', function(event) {
    event.preventDefault(); // Prevent the default link behavior

    // Remove the active class from all tabs and content
    $('.tabs-nav li').removeClass('tab-active');
    $('.tabs-stage > div').hide(); // Hide all tab content
    $('.tabs-stage-images-item').removeClass('tab-active'); // Remove active class from all tab images

    // Add the active class to the clicked tab
    $(this).parent().addClass('tab-active');

    // Show the content associated with the clicked tab
    var target = $(this).attr('href'); // Get the href attribute of the clicked link

    // Show the tab content
    $('.tabs-stage > div' + target).show(); // Show the content associated with the href

    // Add the active class to the corresponding tab image
    $('.tabs-stage-images-item.tab-' + target.split('-')[1]).addClass('tab-active');
  });
   //Shop by sports
   $('.js-tab-col-link').on('mouseover', function(){
     var currentLinkIndex = $(this).index();
     console.log(currentLinkIndex);
     $('.tabs-stage-images-item:visible .js-tab-image-preview').eq(currentLinkIndex).addClass('active').siblings().removeClass('active')
     $(this).addClass('active').siblings().removeClass('active')
   })

   $('.custom-featured-collection-right').slick({
    dots: true,
    infinite: false,
    speed: 300,
       accessibility:true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
   $('.custom-feature-product-img-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  infinite: false,
  arrows: false,
  fade: true,
  asNavFor: '.custom-feature-product-slider'
});

   
$(function() {
     $('.custom-feature-product-slider').on('init', function(event, slick) {
          $(this).append('<div class="slick-counter"><span class="current"></span> / <span class="total"></span></div>');
          $('.current').text(slick.currentSlide + 1);
          $('.total').text(slick.slideCount);
     })
          .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: '.custom-feature-product-img-slider',
          dots: false,
           infinite: false,
          focusOnSelect: true
     })
          .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          $('.current').text(nextSlide + 1);
     });
});
   
$('.header__icon--menu').click(function(){
$('.mobile-search-bar').toggle();
})
  $('.show-description').click(function() {
  $('.collection-hero__description').addClass('show');
   $(this).addClass('show');
});
 $('.facet-filters-mobile').click(function() {
  $('.facets-vertical .facets').addClass('show');
});
$('.facet-filters-form-mobile span').click(function() {
  $('.facets-vertical .facets').removeClass('show');
});
   $('.filter-bottom-btn>span').click(function() {
  $('.facets-vertical .facets').removeClass('show');
});
});

$(document).ready(function(){
    $('.sizechart-link').magnificPopup({
      type:'inline',
      midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });
  $('.sizechart-switch-btn a').click(function(){
    var ind = $(this).index();
    $(this).addClass('active').siblings().removeClass('active');
    $('.sizechart-content-table-main').eq(ind).addClass('active').siblings().removeClass('active');
  })

 setTimeout(() => {
var $slickElements = $('.related-products .product-grid');

$slickElements.slick({
    dots: true,
    arrows:false,
    infinite: true,
    slidesToShow: 4,
    arrows:true,
    swipeToSlide:true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1026,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
});

  }, 3000);
});


$('.list-menu .dropdown-toggle').click(function () {
  $(this).toggleClass('oopen').siblings().removeClass('oopen');;
  $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });
});
let lastClickedButton = null;

$(document).on('click', '.dropdown-toggle', function() {
  // Store a reference to the clicked button
  lastClickedButton = $(this);
});

$(document).on('keydown', function(e) {
  if (e.key === "Escape") {
    $(".dropdown-toggle").removeClass("oopen");
    $(".dropdown-toggle").attr('aria-expanded', 'false');
    
    if (lastClickedButton) {
      lastClickedButton.focus();
    }
  }
});

$(document).ready(function () {
     $('.slick-slide').removeAttr('role');
$('.slick-dots').removeAttr('role');
$('.slick-dots .slick-active').removeAttr('role');
$('.slick-dots button').removeAttr('role');
   
   });
$('.best-seller-slider').on('init', function(event, slick){
  $(this).prepend('<p class="sr-only">This is a carousel with product cards. Use the previous and next buttons to navigate.</p>');
});
$('.custom-featured-collection-right').on('init', function(event, slick){
  $(this).prepend('<p class="sr-only">This is a carousel with product cards. Use the previous and next buttons to navigate.</p>');
});

$(document).on('click', '#AjaxinatePagination a', function(e) {
  e.preventDefault();
  var nextUrl = $(this).attr('href');
  $.ajax({
    url: nextUrl,
    type: 'GET',
    success: function(data) {
      var newPagination = $(data).find('#AjaxinatePagination');
      $('#AjaxinatePagination').html(newPagination.html());
      var currentViewingInfo = $('.viewing').text().match(/\d+/g);  
      var newViewingInfo = $(data).find('.viewing').text().match(/\d+/g); 

      if (currentViewingInfo && newViewingInfo) {
        var currentStart = parseInt(currentViewingInfo[0], 10); 
        var currentEnd = parseInt(currentViewingInfo[1], 10);  
        var totalProducts = parseInt(newViewingInfo[2], 10); 
        
        var newEnd = Math.min(currentEnd + (currentEnd - currentStart + 1), totalProducts);
        
        $('.viewing').text(`Viewing ${currentStart}-${newEnd} of ${totalProducts} Products`);
        runAjaxinate();
      }
    }
  });
});
$(document).on('init reInit afterChange', '.slick-slider', function(event, slick, currentSlide, nextSlide){
  $('button').each(function() {
    var ariaDisabled = $(this).attr('aria-disabled');

    if (ariaDisabled === 'true') {
      $(this).attr('tabindex', '-1');
    } else if (ariaDisabled === 'false') {
      $(this).removeAttr('tabindex');
    }
  });
});

